import { render, staticRenderFns } from "./AuthNavbar.vue?vue&type=template&id=2d1635fc&scoped=true&"
import script from "./AuthNavbar.vue?vue&type=script&lang=js&"
export * from "./AuthNavbar.vue?vue&type=script&lang=js&"
import style0 from "./AuthNavbar.vue?vue&type=style&index=0&id=2d1635fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1635fc",
  null
  
)

export default component.exports